export const MenuItems = [
    {
        "title": "الرئيسية",
        "url": "#",
        "cName": "nav-links",
        "link": "/"
    },
    {
        "title": "المكتبة",
        "url": "#",
        "cName": "nav-links",
        "link": "/sections"
    },
    {
        "title": "حديث اليوم",
        "url": "#",
        "cName": "nav-links",
        "link": "/islamictheend"
    },
    {
        "title": "رسالة اليوم",
        "url": "#",
        "cName": "nav-links",
        "link": "/islamicsms"
    },
    {
        "title": "مواقيت الصلاة",
        "url": "#",
        "cName": "nav-links",
        "link": "/prayertime"
    },
    {
        "title": "القرآن",
        "url": "#",
        "cName": "nav-links",
        "link": "/quran"
    },
    {
        "title": "في الذاكرة",
        "url": "#",
        "cName": "nav-links",
        "link": "/newRegister"
    }
] 
